import postAPI from './postAPI.js'

export default async function postUpdateTaskInstanceStatus(body) {
    const data = await postAPI('taskinstances/updatestatus', body);
    return data;
}
